export const testimonials = [
  {
    text: "Отличная работа! Полусухая стяжка 200 м² выполнена за один день. Качество проверки на высоте — каждый день приезжал контролёр. Очень довольны.",
    name: "Магомед А.",
    role: "Частный заказчик",
  },
  {
    text: "Механизированная штукатурка — это совсем другой уровень! Стены идеально ровные, экономия времени и материалов. Профессиональная команда.",
    name: "Зарема М.",
    role: "Владелица квартиры",
  },
  {
    text: "Работали на нашем объекте строительства. Всё чётко, в срок, с соблюдением технологии. Рекомендую как надёжного подрядчика.",
    name: "Руслан Х.",
    role: "Прораб",
  },
] as const;
